let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k150Y")).then(() => parcelRequire('d9G69'));